import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../service/local-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';

@Component({
  selector: 'app-sub-event-donor',
  templateUrl: './sub-event-donor.component.html',
  styleUrl: './sub-event-donor.component.scss'
})
export class SubEventDonorComponent implements OnInit{
  getSubEventListMain: any;
  getSubEventList: any;
  eventId: any;
  userTypeId: any;
  label: any;

  constructor(
    private mainService: MainService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,    
  ) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.label = this.userTypeId == 1 ? 'આમંત્રણ અને હાજર સભ્ય' : 'આમંત્રણ'
    this.route.params.subscribe((params: any) => {
      this.eventId = params['event_id'] || '';
    });
  }

  ngOnInit(): void {
    this.getSubEventListData();
  }

  getSubEventListData() {
    this.mainService.getApi(ApiUrls.subEventList + this.eventId).subscribe(res => {
      this.getSubEventListMain = res.sub_event;
      this.getSubEventList = res.sub_event;
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getSubEventList = this.getSubEventListMain
      return;
    }
    this.getSubEventList = this.getSubEventListMain.filter((user: any) => {
      return user.sub_event_name.toLowerCase().includes(filterValue)
    });
  }

  goToEventDonor(data: any) {
    this.router.navigate(["event-donor-list/" + data.sub_event_id]);
  }
  
}
